import {
   GET_LIST_PENILAIAN,
   GET_PENILAIAN_ID,
   GET_REVIEW_COUNT,
   GET_LIST_KATEGORI_ADMIN,
   GET_LIST_KOMPETENSI_ADMIN,
   ADD_NEW_KATEGORI,
   GET_DETAIL_KATEGORI,
   GET_DETAIL_KOMPETENSI,
   RESET_DETAIL_KATEGORI,
   RESET_DETAIL_KOMPETENSI
  } from 'shared/constants/ActionTypes';
  
  const listPenilaian = {
    count:null,
    next:null,
    previous:null,
    results:[]
  }

  const reviewCount = {
    success:null,
    message:null,
    results:[]
  }

  const penilaianId = {
    success:null,
    message:null,
    results:{}
  }

  const initialState = {
    listPenilaian: listPenilaian,
    reviewCount:reviewCount,
    penilaianId:penilaianId,
    listKategori: [],
    listKompetensi: [],
    detailKategori: null,
    detailKompetensi: null
  };
  
  const kmAdminReducer = (state = initialState, action) => {
    switch (action.type) {
     
      case GET_LIST_PENILAIAN: {
        return {...state, listPenilaian: action.payload};
      }
      case GET_REVIEW_COUNT: {
        return {...state,reviewCount:action.payload}
      }
      case GET_PENILAIAN_ID: {
        return {...state,penilaianId:action.payload}
      }
      case GET_LIST_KATEGORI_ADMIN: {
        return {...state,listKategori:action.payload}
      }
      case GET_LIST_KOMPETENSI_ADMIN: {
        return {...state,listKompetensi:action.payload}
      }
      case ADD_NEW_KATEGORI: {
        return {...state}
      }
      case GET_DETAIL_KATEGORI: {
        return {...state,detailKategori:action.payload}
      }
      case GET_DETAIL_KOMPETENSI: {
        return {...state,detailKompetensi:action.payload}
      }
      case RESET_DETAIL_KATEGORI: {
        return {...state,detailKategori:null}
      }
      case RESET_DETAIL_KOMPETENSI: {
        return {...state,detailKompetensi:null}
      }
      default: {
        return state;
      }
    }
  };
  export default kmAdminReducer;
  